import { useCallback } from "react";
import { graphql, useMutation } from "react-relay/hooks";

import type {
  changeFlightDataFilesAccessRulesMutation,
  CloudApiFileUsageFileUsageReason,
} from "__generated__/changeFlightDataFilesAccessRulesMutation.graphql";

export const ChangeFlightDataFilesAccessRules = graphql`
  mutation changeFlightDataFilesAccessRulesMutation(
    $flightIds: [ID]
    $fileIds: [ID]
    $fileUsage: CloudApiFileUsageFileUsageReason
    $nonCji: Boolean
  ) {
    changeFlightDataFilesAccessRules(
      flightIds: $flightIds
      fileIds: $fileIds
      fileUsage: $fileUsage
      nonCji: $nonCji
    ) {
      errors
      flights {
        id
        fileReleaseStatus
        cjiStatus
        dataFiles {
          edges {
            node {
              id
              fileUsage
              isCji
            }
          }
        }
      }
      dataFiles {
        id
        fileUsage
        isCji
      }
    }
  }
`;

interface ChangeFlightDataFilesAccessRulesVariables {
  flightIds: string[] | null | undefined;
  fileIds: string[] | null | undefined;
  fileUsage: CloudApiFileUsageFileUsageReason | null | undefined;
  nonCji: boolean | null | undefined;
}

export const useChangeFlightDataFilesAccessRules = (
  onComplete?: (response: changeFlightDataFilesAccessRulesMutation["response"]) => void,
  onError?: (error: Error) => void
) => {
  const [changeFlightDataFilesAccessRules, loading] =
    useMutation<changeFlightDataFilesAccessRulesMutation>(ChangeFlightDataFilesAccessRules);
  const callback = useCallback(
    (vars: ChangeFlightDataFilesAccessRulesVariables) => {
      changeFlightDataFilesAccessRules({
        variables: {
          flightIds: vars.flightIds,
          fileIds: vars.fileIds,
          fileUsage: vars.fileUsage,
          nonCji: vars.nonCji,
        },
        onCompleted: onComplete,
        onError: onError,
      });
    },
    [changeFlightDataFilesAccessRules, onComplete, onError]
  );
  return [callback, loading] as const;
};
